import { createClient } from '@supabase/supabase-js'

// These values come from your Supabase project dashboard
// Settings → API → Project URL and anon/public key
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('Missing Supabase environment variables. See SETUP.md.')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    // Stay signed in across reloads/closures until the user taps Sign Out.
    // - persistSession + storage:localStorage → session survives tab close + restart.
    // - autoRefreshToken → access token auto-refreshes before expiry, as long as
    //   the refresh token is still valid. Refresh-token lifetime is set in the
    //   Supabase dashboard (Authentication → Sessions); set it high (e.g. 1 year)
    //   to keep returning users logged in indefinitely.
    // - detectSessionInUrl → handles OAuth / magic-link callbacks.
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
})
